import * as React from "react";
type Props = {
  className?: string,
};
function SvgPeanutfree({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Peanut free"
      className={className}
    >
      <path
        d="M15.5431 10.7215C15.5431 10.7215 13.1489 12.6274 15.4635 14.8859M18.2383 23.5939C18.2383 23.5939 16.4098 27.8734 19.7415 29.5323M8.106 34.2624L14.5614 26.5259M21.8215 17.8252L31.7436 5.93379M28.5513 23.8322C27.8159 19.3852 22.7287 19.6876 21.6187 17.5081C20.277 14.8727 23.1934 12.4224 21.5486 9.93375C18.3541 5.10032 9.23082 9.66158 11.805 14.7251C13.0825 17.2388 16.8199 17.48 16.0565 20.8589C15.462 23.4899 13.3746 26.9699 15.4495 29.5315C19.9997 35.1461 29.7167 30.8858 28.5513 23.8322ZM19.9997 38.5714C30.2566 38.5714 38.5714 30.2566 38.5714 19.9997C38.5714 14.585 36.2539 9.71247 32.5571 6.31734C29.252 3.28142 24.8419 1.42859 19.9997 1.42859C9.74345 1.42859 1.42859 9.74345 1.42859 19.9997C1.42859 30.2566 9.74345 38.5714 19.9997 38.5714Z"
        stroke="currentColor"
      />
    </svg>
  );
}
export default SvgPeanutfree;
